import React from "react";
import checkIcon from "../../../images/Double-check.svg";

const SideColumnCard = props => {
  const { imageUrl, heading, points, btnLabel, btnUrl } = props;

  return (
    <div className="flex-col m-auto justify-center align-center shadow-normal rounded sideColumnCardWrapper">
      <img src={imageUrl} alt={heading} height="90px" />
      <p className="heading-3 bold spacer_lg">{heading}</p>
      {points.map((point, id) => (
        <div className="flex border-1 w-100 rounded para-3 bg-white spacer_sm sideColumnCardPoint">
          <img src={checkIcon} alt="" style={{ marginRight: "8px" }} />
          <span style={{ fontFamily: "Hind Madurai" }}>{point}</span>
        </div>
      ))}
      <a href={btnUrl}>
        <div className="flex btn-secondary-filled align-center spacer_md justify-center cardButton">{btnLabel}</div></a>
      <style jsx>{`
        .sideColumnCardWrapper{
          box-sizing:border-box;
          padding:16px;
          margin-bottom:30px;
        }
        .sideColumnCardPoint{
          box-sizing:border-box;
          padding:12px ;
        }
        .cardButton{
          height:35px;
          width:144px;
        }
        @media screen and (max-width: 768px) {
          .sideColumnCardWrapper {
            padding: 15px;
            margin: 0;
            width: 47%;
          }
        }
        @media screen and (max-width: 600px) {
          .sideColumnCardWrapper {
            width: 100%;
            margin-bottom: 30px;
          }
          .sideColumnCardPoint {
            line-height: 40px;
            width: 100%;
          }
        }
        `}</style>

    </div>
  );
};
export default SideColumnCard;
